<template>
  <div class="table-wrap">
    <table>
      <thead>
      <tr>
        <th v-for="item,index in tableData.th" :key="index">{{item}}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item,index in tableData.tb" :key="index">
        <td v-for="v,i in item" :key="i" :class="v==='是'?'yes':v==='否'?'no':''">{{v}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: "tablecomp",
    props: {
      tableData: {
        type: Object,
        default: () => {

        }
      }
    },
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style lang="scss" scoped>
  .table-wrap {
    width: 100%;
    height: calc(100% - 30px);
    overflow-y: auto;
    table {
      font-size: 14px;
      width: 100%;
      tr {
        text-align: center;
        height: 35px;
        line-height: 35px;
        box-sizing: border-box;
        border-bottom: 1px #083b38 solid;
        /*&:nth-last-child(1) {
          border-right: none;
        }*/
      }
      thead {
        color: #bffffb;
        tr {
          th {
            font-weight: bold;
            text-align: center;
            border-right: 1px #083b38 solid;
            &:nth-last-child(1) {
              border-right: none;
            }
          }
        }
      }
      tbody {
        color: #ebfefd;
        tr {
          td {
            text-align: center;
            border-right: 1px #083b38 solid;
            &:nth-last-child(1) {
              border-right: none;
            }
          }
          .yes {
            color: #1eb0fc;
          }
          .no {
            color: #f03b28;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/pollute/tables/tablecomp.vue